// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../fetch.pb.js";
export var PredicateOperator;
(function (PredicateOperator) {
    PredicateOperator["UNKNOWN"] = "UNKNOWN";
    PredicateOperator["EQUALS"] = "EQUALS";
})(PredicateOperator || (PredicateOperator = {}));
export var PredicateOperator_index;
(function (PredicateOperator_index) {
    PredicateOperator_index[PredicateOperator_index["UNKNOWN"] = 0] = "UNKNOWN";
    PredicateOperator_index[PredicateOperator_index["EQUALS"] = 1] = "EQUALS";
})(PredicateOperator_index || (PredicateOperator_index = {}));
export var SmsStatus;
(function (SmsStatus) {
    SmsStatus["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
    SmsStatus["STATUS_DELIVERED"] = "STATUS_DELIVERED";
    SmsStatus["STATUS_ERROR"] = "STATUS_ERROR";
    SmsStatus["STATUS_NEW"] = "STATUS_NEW";
    SmsStatus["STATUS_NOT_SENT"] = "STATUS_NOT_SENT";
    SmsStatus["STATUS_READ"] = "STATUS_READ";
    SmsStatus["STATUS_RECEIVED"] = "STATUS_RECEIVED";
    SmsStatus["STATUS_SENT"] = "STATUS_SENT";
    SmsStatus["STATUS_UNSPECIFIED"] = "STATUS_UNSPECIFIED";
})(SmsStatus || (SmsStatus = {}));
export var SmsStatus_index;
(function (SmsStatus_index) {
    SmsStatus_index[SmsStatus_index["UNKNOWN_STATUS"] = 0] = "UNKNOWN_STATUS";
    SmsStatus_index[SmsStatus_index["STATUS_DELIVERED"] = 1] = "STATUS_DELIVERED";
    SmsStatus_index[SmsStatus_index["STATUS_ERROR"] = 2] = "STATUS_ERROR";
    SmsStatus_index[SmsStatus_index["STATUS_NEW"] = 3] = "STATUS_NEW";
    SmsStatus_index[SmsStatus_index["STATUS_NOT_SENT"] = 4] = "STATUS_NOT_SENT";
    SmsStatus_index[SmsStatus_index["STATUS_READ"] = 5] = "STATUS_READ";
    SmsStatus_index[SmsStatus_index["STATUS_RECEIVED"] = 6] = "STATUS_RECEIVED";
    SmsStatus_index[SmsStatus_index["STATUS_SENT"] = 7] = "STATUS_SENT";
    SmsStatus_index[SmsStatus_index["STATUS_UNSPECIFIED"] = 8] = "STATUS_UNSPECIFIED";
})(SmsStatus_index || (SmsStatus_index = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["UNKNOWN_SORT"] = "UNKNOWN_SORT";
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var SortOrder_index;
(function (SortOrder_index) {
    SortOrder_index[SortOrder_index["UNKNOWN_SORT"] = 0] = "UNKNOWN_SORT";
    SortOrder_index[SortOrder_index["ASC"] = 1] = "ASC";
    SortOrder_index[SortOrder_index["DESC"] = 2] = "DESC";
})(SortOrder_index || (SortOrder_index = {}));
export const SearchService = {
    Search(fn, req) {
        return fn(`/search/v1/search:register`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    Ingest(fn, req) {
        return fn(`/search/v1/ingest:register`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    Delete(fn, req) {
        return fn(`/search/v1/delete:register`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
};
